import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'

import auth from './auth'
import metrics from './metrics'
import providers from './providers'

Vue.use(api)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    notification: {
      group: 'global', duration: 3000
    },
    pageSize: 30,
    successMessage: {}
  },
  modules: {
    auth: auth,
    metrics: metrics,
    providers: providers
  },
  mutations: {
    'API_REQUEST' (state) {
      state.errorMessage = null
      state.request_start = true
      state.request_success = false
      state.request_error = false
    },
    'API_REQUEST_SUCCESS' (state, payload) {
      state.request_success = true
      state.request_start = false
    },
    'API_REQUEST_ERROR' (state, payload) {
      Object.assign(payload, { group: 'global', type: 'error', duration: 4000 })
      state.notification = payload
      state.request_error = true
      state.request_start = false
    }
  },
  actions: {
    async request ({ commit, state, getters, rootState }, config) {
      commit('API_REQUEST')
      var url = `${getters.apiURL}${config.url}/`
      var headers = getters.apiHeaders
      return api.request(config.method, headers, url, config.data, config.params
      ).then(response => {
        commit('API_REQUEST_SUCCESS', response.data)
        return response
      }).catch(error => {
        commit('API_REQUEST_ERROR', {
          title: 'ERROR',
          type: 'error',
          text: apiErrorToHTML(error.response.data, this)
        })
        throw error
      })
    },

    async list ({ dispatch, commit, state }, config) {
      return this.dispatch('request', {
        method: 'get',
        url: config.basePath,
        params: config.params
      })
        .then(response => {
          var count = 'count' in response.data ? response.data.count : response.data.length
          var results = 'results' in response.data ? response.data.results : response.data
          return {count: count, results: results}
        }).catch(error => {
          throw error
        })
    },
    async read ({ dispatch, commit, state }, config) {
      var url = `${config.basePath}/${config.id}`
      if (!config.id) {
        return undefined
      }
      return dispatch('request', {method: 'get', url: url})
        .then(response => { return response.data })
        .catch(error => { throw error })
    },
    async save ({ dispatch, commit, state, rootState }, config) {
      var url = config.basePath
      var method = 'post'
      if (config.id > 0) {
        url = `${url}/${config.id}`
        method = 'put'
      }
      return dispatch('request', { method: method, url: url, data: config.data })
        .then(response => {
          state.object = response.data
          return state.object
        }).catch(error => {
          throw error
        })
    },
    async delete ({ dispatch, commit, state, rootState }, config) {
      var ModelClass = config.modelClass
      var url = (config.basePath ? config.basePath : ModelClass.defaults().basePath) + '/' + config.id
      return dispatch('request', { method: 'delete', url: url, data: config.data })
        .then(response => {
          state.object = response.data
          return state.object
        }).catch(error => { throw error })
    }
  },
  getters: {
    apiURL () {
      return Vue.config.app.API_URL
    },
    apiHeaders (state) {
      if (!state.auth.authenticated) { return {} }
      return { 'Authorization': 'Token ' + state.auth.token }
    },
    pageSize (state) { return state.pageSize }
  }
})
function apiErrorToHTML (error) {
  var html = ''
  Object.keys(error).forEach(key => {
    html += `<label>${key}</label>`

    if (error[key].isArray) {
      html += `<ul><li>${error[key].join('</li><li>')}</li></ul>`
    } else {
      html += `<div>${error[key]}</div>`
    }
  })
  return html
}

/* function apiErrorToHTML (error, context) {
  var html = ''
  if (error.data) {
    Object.keys(error.data).forEach(key => {
      html += `<label>${key}</label>`

      if (Array.isArray(error.data[key])) {
        html += `<ul><li>${error.data[key].join('</li><li>')}</li></ul>`
      } else {
        var include = false
        Object.keys(error.data[key]).forEach(childKey => {
          if (Array.isArray(error.data[key][childKey])) {
            html += `<ul><li>${error.data[key][childKey].join('</li><li>')}</li></ul>`
          } else {
            include = true
          }
        })
        if (include) {
          html += `<div>${error.data[key]}</div>`
        }
      }
    })
  } else {
    html = context._vm.$ml.get(error.status.toString())
  }
  return html
}
 */



// WEBPACK FOOTER //
// ./src/store/index.js